module.exports = __webpack_public_path__ + "img/Kate - Slider 02.c28f3778.jpg";